import createArticleAPI from "./article";

export default (options) => ({
    article: createArticleAPI(options),
   
});
